/**
 * Firebase client initialisation.
 *
 * Configuration comes from REACT_APP_FIREBASE_* environment variables (see
 * .env.example). When REACT_APP_USE_EMULATORS=true the Auth SDK talks to the
 * local Auth emulator so the whole stack runs offline with `npm run dev`.
 */
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
export const auth = getAuth(app);

if (process.env.REACT_APP_USE_EMULATORS === 'true') {
  const host = process.env.REACT_APP_AUTH_EMULATOR_HOST || 'http://127.0.0.1:9099';
  connectAuthEmulator(auth, host, { disableWarnings: true });
}

export default app;
